import { LANDING_PAGE_PREFERENCES } from "@constants/global.constants";

import { isSandboxEnv } from "@utils/appUtils";

import { CalendarIcon, LicenseCardIcon } from "@components/SVGs";

export const PUBLIC_DEFAULT_ID = 1;

export const PROFILE_TAB_ID = {
  myProfileTab: 0,
  licenseDetailTab: 1,
};

export const LICENSE_SECTIONS_CONFIG = [
  { id: "technology", label: "licenseProfile.licenseTechnology", tag: "Technology" },
  { id: "features", label: "licenseProfile.licenseFeatures", tag: "Feature" },
  { id: "product-list", label: "licenseProfile.licenseProductList", tag: "Product" },
];

export const LICENSE_CARD_DETAILS_CONFIG = [
  {
    icon: LicenseCardIcon,
    label: "licenseProfile.licenseName",
    valueKey: "name",
    showKey: null,
    iconProps: {},
  },
  {
    icon: CalendarIcon,
    label: "licenseProfile.licenseAssigneOn",
    valueKey: "assignedDate",
    showKey: "assignedDate",
    iconProps: {},
  },
  {
    icon: CalendarIcon,
    label: "licenseProfile.licenseExpiringOn",
    valueKey: "expiryDate",
    showKey: "expiryDate",
    iconProps: { fill: "var(--du-color-red)" },
  },
];

export const USER_ROLES = {
  superAdmin: "Super Admin",
  licenseAdmin: "License Admin",
  warrantyAdmin: "Warranty Admin",
  databaseAdmin: "Database Admin",
  standardUser: "Standard User",
};

export const USER_ROLES_CONFIG = [
  {
    id: 1,
    name: USER_ROLES.superAdmin,
    isBasic: true,
    isLicenseManagement: true,
    isWarrantyManagement: !isSandboxEnv(),
    isUserManagement: true,
    isDatabaseManagement: true,
  },
  {
    id: 2,
    name: USER_ROLES.licenseAdmin,
    isBasic: true,
    isLicenseManagement: true,
    isWarrantyManagement: false,
    isUserManagement: false,
    isDatabaseManagement: false,
  },
  {
    id: 3,
    name: USER_ROLES.warrantyAdmin,
    isBasic: true,
    isLicenseManagement: false,
    isWarrantyManagement: !isSandboxEnv(),
    isUserManagement: false,
    isDatabaseManagement: false,
  },
  {
    id: 4,
    name: USER_ROLES.databaseAdmin,
    isBasic: true,
    isLicenseManagement: false,
    isWarrantyManagement: false,
    isUserManagement: false,
    isDatabaseManagement: true,
  },
  {
    id: 5,
    name: USER_ROLES.standardUser,
    isBasic: true,
    isLicenseManagement: false,
    isWarrantyManagement: false,
    isUserManagement: false,
    isDatabaseManagement: false,
  },
];

export const HOME_PAGE_RADIO_CONFIG = [
  {
    labelKey: "homeProjects.recentProjects",
    landingPageId: LANDING_PAGE_PREFERENCES.RECENT_PROJECTS,
  },
  {
    labelKey: "projectMenu.exampleProjects",
    landingPageId: LANDING_PAGE_PREFERENCES.EXAMPLE_PROJECTS,
  },
  {
    labelKey: "myProfile.noProjects",
    landingPageId: LANDING_PAGE_PREFERENCES.NO_PROJECTS,
  },
];
export const RECENT_PROJECTS_COUNT = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 5, label: "5" },
  { value: 10, label: "10" },
];

export const LICENSE_FEATURES_PERMISSION = {
  PITZER: "Pitzer",
  EXPERIMENTAL_ELEMENT: "Experimental Element",
  CUSTOMIZATION_FACTORS: "Customization Factors",
  MLD: "MLD",
};

export const LICENSE_PRODUCTS_PERMISSION = {
  LITHIUM: "Li",
};

export const LICENSE_FEATURES_DISPLAY_LABEL = {
  [LICENSE_FEATURES_PERMISSION.PITZER]: "Advanced Water Model",
};
